module.exports = __webpack_public_path__ + "img/ticket.24e6f81d.png";